<template lang="pug">
  .login.login-app
    closeCtrl(@on-close='toggleLogin', @touchmove='handlePrevent')
    .login-wrap
      .login-top
        img(:src="bgImg", alt="登陆注册")
        //- van-tabs(v-model="tabActive")
        //-   van-tab(title='注册', disabled)
        //-   van-tab(title='登陆')

      .login-body
        .field
          el-input(
            type="text",
            placeholder="请输入用户名",
            v-model="username",
            clearable)
        .field
          el-input(
            type="password",
            placeholder="密码",
            v-model="password",
            required,
            clearable)

        .authorize.tac(@click="authorize", v-if='isWxBrowser')
          p 使用第三方快捷登录
          .link-wrap
            span
              i.iconfont.icon-wechat

      .login-foot.pos-a
        el-button(type="success", @click='handleLogin', style='width: 100%') 登陆

</template>

<script>
import loginMixin from '@/mixins/login'
import { getPhoneType } from '@/utils'
export default {
  name: 'loginPc',
  mixins: [loginMixin],
  created() {
    this.bgImg = `${window.$globalconfig.URLS.API}krpano/images/signup_bg.jpg`
  },
  computed: {
    isWxBrowser() {
      return getPhoneType('weixin')
    },
  },
  methods: {
    authorize() {
      const redirect = `${window.$globalconfig.URLS.VIDEO_VIEW_PREFIX.split('?')[0]}signature?videoid=${this.$route.query.videoid}`
      window.location.href = window.$global.WxauthUrl + redirect
    },
    handlePrevent(ev) {
      ev.preventDefault()
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/styles/mixins.styl'
@import '../../assets/styles/variables.styl'
$font-color = #606266
$border-color = #DCDFE6
$success = #67C23A
$gray-dark = #D3DCE6
$gray = #E5E9F2
.login-app
  full-cover()
  background-color: #f9f9f9
  overflow: hidden
  z-index: $--zindex-high
  .login-wrap
    .login-top
      position: relative
      width: 100%
      height: 0
      padding-top: 50%
      img
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%

    .login-body
      position: relative
      padding: 30px 20px

      .field
        width: 100%
        margin-bottom: 10px

      .authorize
        font-size: 14px
        padding-top: 20px
        color: $gray-dark
        .link-wrap
          font-size: 0
          padding: 10px
          span
            display: inline-block
            vertical-align: middle
            width: 40px
            height: 40px
            font-size: 14px
            color: $gray
            border-radius: 50%
            border: 1px solid #fff
            i
              margin-left: 4px
              font-size: 32px
              color: $success
    .login-foot
      width: 100%
      left: 0
      right: 0
      bottom: 0
</style>
